module.exports = __webpack_public_path__ + "457dfd599d720120c11d7ba66bb5f8e7.MP3";